import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from '@angular/core';
import { utils } from './utils';

@Component({
  selector: 'app-decoder',
  templateUrl: 'decoder.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host{width:100%}']
})

export class DecoderComponent implements OnInit {

    @Input() public code: string;
    @Input() public type: any = [1,2,3];
    public decoded = [];

    constructor(private cdr: ChangeDetectorRef) {

    }

    ngOnInit() {

        const code_parts = this.code.replace('M_', '').split('_');
        if (code_parts.length > 1) {
            const decode = code_parts[0].split('.');
            let letters;
            let boat = decode[0].charAt(0) == 'B' ? true : false;
            let i = 1;
            if (this.type.includes(1)) {
                if (decode[1]) this.decoded.push({name: $localize `DMC`, value: +decode[1] *10});
                // if (decode[2]) this.decoded.push({name: $localize `Długość przestrzeni ładunkowej`, value: +decode[2] *10});
                // if (decode[3]) this.decoded.push({name: $localize `Szerokość przestrzeni ładunkowej`, value: +decode[3] *10});
                // if (decode[4]) this.decoded.push({name: $localize `Numer serii`, value: decode[4]});
            }

            //basic data
            if (this.type.includes(2)) {
                letters = [...decode[0]];
                letters.forEach(letter => {
                    if(i == 1) {
                        this.decoded.push({name: $localize `Rodzaj przyczepy`, value: (utils.decoder_types[letter] ? utils.decoder_types[letter]['client'] : '-')});
                    }
                    if(i == 2) {
                        this.decoded.push({name: $localize `Liczba osi`, value: (utils.decoder_axis[letter] ? utils.decoder_axis[letter]['client'] : '-')});
                    }
                    if(i == 3) {
                        this.decoded.push({name: $localize `Rodzaj zawieszenia`, value: (utils.decoder_suspension[letter] ? utils.decoder_suspension[letter]['client'] : '-')});
                    }
                    if(i == 4) {
                        this.decoded.push({name: $localize `Rodzaj dyszla`, value: (utils.decoder_drawbars[letter] ? utils.decoder_drawbars[letter]['client'] : '-')});
                    }
                    if(i == 5) {
                        this.decoded.push({name: $localize `Pozycja koł`, value: (utils.decoder_wheels[letter] ? utils.decoder_wheels[letter]['client'] : '-')});
                    }
                    i++;
                });
            }


            //configured data
            if (this.type.includes(3)) {
                let p  = 0;
                let length = code_parts.length - 1; //without first seg
                let additional_index = -1;
                
                code_parts.forEach(part => {
                    if (p > 0) {
                        letters = [...part];
                        if (p == 3) {
                            letters = part.split(/(?=[A-Z])/);
                        }
                        i = 1;

                        letters.forEach(letter => {
                            // console.log(letters);
                            // console.log(utils.decoder_segments[p][i], p, i);

                            let add  = true;
                            if (p == 3 && i == 1 && ['T', 'U', 'V'].includes(letter)) {
                                this.decoded.push({name: utils.decoder_segments[2][i]['name']['client'], value: (utils.decoder_segments[2][i][letter] ? utils.decoder_segments[2][1][letter]['client'] : '-')});
                            }

                            if (utils.decoder_segments[p][i]) {

                                let add = true;
                                if (p == 1 && i == 1) { // remove marka osi
                                    add = false;
                                }
                                // console.log(add);
                                if (add) {

                                    if (utils.decoder_segments[p][i]['name']['client'] == 'Wyposażenie') {
                                        if (!this.type.includes(4)) {
                                            if (additional_index < 0) {
                                                this.decoded.push({name: utils.decoder_segments[p][i]['name']['client'], value: (utils.decoder_segments[p][i][letter] ? utils.decoder_segments[p][i][letter]['client'] : '-')});
                                                additional_index = this.decoded.length-1;
                                            } else {
                                                this.decoded[additional_index].value += ', '+utils.decoder_segments[p][i][letter]['client'];
                                            }
                                        }
                                    } else {

                                        
                                        let decoder_segments_index = i;
                                        if (boat && p == 1 && i == 2) {
                                            decoder_segments_index = 5;
                                        }

                                        this.decoded.push({name: utils.decoder_segments[p][decoder_segments_index]['name']['client'], value: (utils.decoder_segments[p][decoder_segments_index][letter] ? utils.decoder_segments[p][decoder_segments_index][letter]['client'] : '-')});
                                    }
                                }
                            }
                            if (p < 3) i++;
                        });

                        if (length == 2) p++;
                    }
                    p++;
                });
            }
        }

    }
}